export default "__VITE_ASSET__DHfVZBde__"